import PropTypes from 'prop-types';
import React from 'react';
import { FaIcon } from 'ravenjs/lib';
import styled from 'styled-components';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';
import SubNavActions from './SubNavActions';
import SubNavItems from './SubNavItems';
import SubNavTitle from './SubNavTitle';

import SubNavigationStyled from './SubNavigationStyled';

const BackButton = styled.div`
    display: flex;
    white-space: nowrap;
    align-items: center;
    height: 69px;
    border-right: 1px solid ${MIGRATED_COLORS.literalE6eaee};
    font-size: 24px;
    flex: 0 0 51px;
    max-width: 51px;
    cursor: pointer;
    justify-content: center;
`;

function SubNavigation(props) {
    const { ActionsComponent, items, show, caption, handleBackClick, subtitle, title } = props;

    function onBackClick() {
        if (typeof handleBackClick === 'function') {
            handleBackClick();
            return;
        }
        // return to the previous view
        window.history.back();
    }

    return (
        <SubNavigationStyled show={show}>
            <BackButton onClick={onBackClick}>
                <FaIcon icon={faChevronLeft} />
            </BackButton>
            <SubNavTitle caption={caption} subtitle={subtitle} title={title} />
            <SubNavItems items={items} />
            {ActionsComponent && (
                <SubNavActions>
                    <ActionsComponent />
                </SubNavActions>
            )}
        </SubNavigationStyled>
    );
}

SubNavigation.propTypes = {
    /**
     * Component to add actions to the SubNavigation
     */
    ActionsComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
    /**
     * The caption rendered next to the title.
     */
    caption: PropTypes.string,
    /**
     * List of navigational items
     */
    items: PropTypes.arrayOf(
        PropTypes.shape({
            /**
             * The title to display for the NavLink
             */
            title: PropTypes.string,
            /**
             * The URL for the NavLink
             */
            to: PropTypes.string,
        })
    ),
    /**
     * Should we hide or show the sub navigation?
     */
    show: PropTypes.bool,
    /**
     * The sub-title rendered above the title.
     */
    subtitle: PropTypes.string,
    /**
     * The main title for the sub-navigation.
     */
    title: PropTypes.string,
    /**
     * Custom function that handles the back button click event
     */
    handleBackClick: PropTypes.func,
};

SubNavigation.defaultProps = {
    ActionsComponent: 'div',
    caption: '',
    items: [],
    show: false,
    subtitle: '',
    title: '',
    handleBackClick: null,
};

export default SubNavigation;
